var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ActivityIndicator, TouchableOpacity } from "react-native";
import styled from "../../theme/styled-components.native";
import ListItemSelect from "../ListItemSelect";
export var Wrap = styled(TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: ", ";\n"], ["\n  opacity: ", ";\n"])), function (props) { return (props.isArchived ? 0.5 : 1); });
export var PropertyListItem = styled(ListItemSelect)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var ActivityIndicatorStyled = styled(ActivityIndicator).attrs(function (props) { return ({
    color: props.theme.colors.global5,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  height: 48px;\n"], ["\n  width: 100%;\n  height: 100%;\n  height: 48px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
